import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'
import DocumentCard from './DocumentCard'
import { ThreeDots } from 'react-loader-spinner'
import { Context } from '../components/context/LanguageWrapper';

const DocumentsList = () => {

    const [documents, setDocuments] = useState([])
    const context = useContext(Context)
    const [loading, setLoading] = useState(false)

    const userLogin = useSelector(state => state.userLogin)
    const { userDetails } = userLogin

    useEffect(() => {
        setLoading(true)
        const fetchDocuments = async () => {

            const headers = {
                headers: {
                    "x-auth-token": userDetails.token,
                    "x-language": context.locale.slice(0, 2),
                }
            };

            const { data } = await axios.get(process.env.REACT_APP_API_ENDPOINT + '/docs', headers)
            setDocuments(data.data)
            setLoading(false)
        }
        fetchDocuments();
    }, [context])

    const results = documents.map((d, index) => <DocumentCard d={d} key={d.id} />)
    const content = !loading? results :
        <div className="col-span-6 mt-12 flex justify-center items-center">
            <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#2f4d44"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
            />
        </div>

    return (
        <>
            <div className="h-24 grid grid-cols-1 gap-y-1">
                {content}
            </div>
        </>
    )
}

export default DocumentsList
